import React from 'react';
import { useOrderContext } from '../../../../hooks/useContexts';
import { BodfsDatePicker } from './BodfsDatePicker';
import { BodfsDateTiles } from './BodfsDateTiles';
import { BodfsDeliveryInstructions } from './BodfsDeliveryInstructions';
export var BodfsDeliveryDetails = function () {
    var showCalendar = useOrderContext().showCalendar;
    return (React.createElement(React.Fragment, null,
        React.createElement(BodfsDateTiles, null),
        showCalendar && React.createElement(BodfsDatePicker, null),
        React.createElement(BodfsDeliveryInstructions, null)));
};
